/**
 * this regex tests for phone numbers to match the following criteria (generated via Copilot):
 * (((\+1|1)(\s|-|\.)?)?)? : Tests for NA country code. Optionally matches '+1' or '1' at the start, followed by an optional space, dash, or dot.
 * \(?\d{3}\)? : Tests for area code. Matches three digits, which may be optionally enclosed in parentheses.
 * (\s|-|\.)? : Tests for common separators between area code and local number. Matches an optional space, dash, or dot.
 * \d{3} : Tests for the first part of the local number. Matches three digits.
 * (\s|-|\.)? : Tests for common separators between parts of the local number. Matches an optional space, dash, or dot.
 * \d{4} : Tests for the second part of the local number. Matches four digits.
 */
const phoneRegex =
  /^(((\+1|1)(\s|-|\.)?)?)?\(?\d{3}\)?(\s|-|\.)?\d{3}(\s|-|\.)?\d{4}$/;

/** @param {string} num */
const isTenDigits = num => /^[0-9]{10}$/.test(num);

/** @param {string} phoneNumber */
export function sanitizePhoneNumber(phoneNumber) {
  // check if phone number is valid, accounting for common formatting symbols
  if (!phoneRegex.test(phoneNumber)) {
    throw new Error(`phone number "${phoneNumber}" could not be sanitized`);
  }

  // remove common formatting symbols for phone numbers
  let sanitizedPhoneNumber = phoneNumber.replaceAll(/\s|-|\(|\)|\+|\./g, '');

  if (sanitizedPhoneNumber.length === 11 && sanitizedPhoneNumber[0] === '1') {
    sanitizedPhoneNumber = sanitizedPhoneNumber.slice(1);
  }

  if (!isTenDigits(sanitizedPhoneNumber)) {
    throw new Error(`phone number "${phoneNumber}" could not be sanitized`);
  }

  return sanitizedPhoneNumber;
}

/** @param {string} phoneNumber */
export default function formatPhoneNumber(phoneNumber) {
  let sanitizedPhoneNumber;
  try {
    sanitizedPhoneNumber = sanitizePhoneNumber(phoneNumber);
  } catch (e) {
    throw new Error(
      'phone number was not provided in the correct format; phone number must be 10 characters long and parseable as a number',
    );
  }

  return `+1 (${sanitizedPhoneNumber.substring(
    0,
    3,
  )}) ${sanitizedPhoneNumber.substring(3, 6)}-${sanitizedPhoneNumber.substring(
    6,
  )}`;
}
